export default "__VITE_ASSET__01e4838e__"